<template>
  <div class="display-element" v-html="value"></div>
</template>

<script>
export default {
  props: {
    value: { type: [String, Number], default: '' },
  },
  setup() {},
};
</script>
